import { CountryCode } from '@carsys/enums/country-code'
import { Locales } from '@carsys/enums/locales'
import { Button } from '@carsys/ui'
import { IVehicleType, VehicleProvider } from '@cbgms/api'
import { UnknownVehicleV2 } from 'app/vehicles/components/UnknownVehicleV2/UnknownVehicleV2'
import { UnknownVehicleFormValues, UnknownVehicleV2Form } from 'app/vehicles/components/UnknownVehicleV2/UnknownVehicleV2Form'
import { SelectionContextProvider } from 'app/vehicles/components/UnknownVehicleV2/context/SelectionContext'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

const DefaultButton = () => {
  const { submitForm } = useFormikContext()
  const { t } = useTranslation()
  return (
    <Button variant='contained' color='primary' onClick={() => submitForm()}>
      {t('vehicle.tree.select')}
    </Button>
  )
}

export interface ISetVehicleOptions {
  finalSelectionMade: boolean
}
interface IUnkownVehicleV2ForTreeProps {
  provider: VehicleProvider
  headerContent: React.ReactNode // headerContent allows you to pass additional fields/things to render next to selection. IE a vin input
  actionButton?: React.ReactElement | null | undefined
  vehicle: IVehicleType | {}
  onTypeSelection?: () => Promise<void>
  onSelection: (vehicle: IVehicleType | {}, options?: ISetVehicleOptions) => void
  staticLicensePlate?: string
  country: CountryCode
  locale: Locales
  typeSelectMode?: boolean
}
export const UnknownVehicleV2ForTree: React.FC<IUnkownVehicleV2ForTreeProps> = ({
  provider,
  headerContent,
  actionButton,
  vehicle,
  staticLicensePlate,
  country,
  onTypeSelection,
  onSelection,
  typeSelectMode
}) => {
  const onSubmit = (v: UnknownVehicleFormValues) => {
    return v
  }
  const onSubmitSuccess = (vehicleResult: UnknownVehicleFormValues) => {
    onSelection?.(
      {
        GenericVehicle: vehicleResult?.vehicle?.GenericVehicle,
        Vin: vehicleResult.Vin,
        Registration: vehicleResult.Registration
      },
      { finalSelectionMade: true }
    )
    onTypeSelection?.()
  }
  return (
    <SelectionContextProvider typeSelectMode={typeSelectMode}>
      <UnknownVehicleV2Form
        forcedProvider={provider}
        onSubmit={onSubmit}
        onSubmitSuccess={onSubmitSuccess}
        vehicle={vehicle}
        initialRegistration={staticLicensePlate}
        initialRegistrationCountry={country}
        typeSelectMode={typeSelectMode}
      >
        {headerContent}
        <UnknownVehicleV2 slotBottomButtons={<div>{actionButton || <DefaultButton />}</div>} typeSelectMode={typeSelectMode} />
      </UnknownVehicleV2Form>
    </SelectionContextProvider>
  )
}
